<template>
  <div>
    <v-btn-toggle v-model="toggle_one" dark mandatory class="btn-toggle">
      <v-btn flat @click="changeLanguage('th')">TH</v-btn>
      <v-btn flat @click="changeLanguage('en')">EN</v-btn>
    </v-btn-toggle>
    <!-- <v-menu transition="slide-y-transition" offset-y left>
      <v-btn icon slot="activator" dark>
        <v-list-tile-avatar size="35">
          <img :src="flagItem.th" v-if="$store.state.locale=='th'">
          <img :src="flagItem.en" v-if="$store.state.locale=='en'">
        </v-list-tile-avatar>
      </v-btn>
      <v-list>
        <v-list-tile @click="changeLanguage('th')">ภาษาไทย</v-list-tile>
      </v-list>
      <v-list>
        <v-list-tile @click="changeLanguage('en')">English</v-list-tile>
      </v-list>
    </v-menu>-->
  </div>
</template>
<script>
import { Trans } from "@/plugins/Translation";

export default {
  data() {
    return {
      // switchLang: "th",
      // flagItem: {
      //   th: require("../../assets/Pos/thai.png"),
      //   en: require("../../assets/Pos/usa.png")
      // },
      toggle_one: 0
    };
  },
  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    }
  },
  methods: {
    changeLanguage(lang) {
      // const lang = e.target.value
      const to = this.$router.resolve({ params: { locale: lang } });
      this.$store.commit("setLang", lang);
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location);
        // this.switchLang = lang;
      });
    },
    isCurrentLanguage(lang) {
      return lang === this.currentLanguage;
    }
  }
};
</script>
<style>
.btn-toggle {
  position: absolute;
  top: 0px;
  right: 10px;
}
@media screen and (max-width: 599px) {
  .btn-toggle {
    top: 0;
    right: 0;
  }
}
</style>

